import script from "./TraitShopCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopCard.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopCard.vue?vue&type=style&index=0&id=0cd18e92&lang=scss"

const __exports__ = script;

export default __exports__